module.exports = __webpack_public_path__ + "static/media/York.2463286c.png";